module.exports = __webpack_public_path__ + "img/ebook-hero-thumb2.9fe0572c.png";